module.exports = __webpack_public_path__ + "static/media/benefits9.0d4363d3.webp";